import React from 'react'
import styled, { css } from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

import { RowRoot } from './leaderboard-row'

export const LeaderboardRowSkeleton: React.FC<{
  rank: number
}> = ({ rank }) => {
  return (
    <RowRoot>
      <Rank>{rank}.</Rank>
      <Skeleton height={15} width={60} />
      <Skeleton height={15} width={50} />
      <div
        css={css`
          justify-self: end;
        `}
      >
        <Skeleton height={15} width={30} />
      </div>
    </RowRoot>
  )
}

const Rank = styled.div`
  color: var(--text-7);
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
`
